import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useErrorService, useNotificationService } from '@abroad/components'
import API from '../../utils/API'
import ExperienceButton from './ExperienceButton'

const SendItineraryNotificationModal = ({
  showModal,
  handleClose,
  questTitle,
  questId,
}) => {
  const [description, setDescription] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const Error = useErrorService()
  const Notification = useNotificationService()

  const handleSendNotification = async () => {
    setIsLoading(true)
    try {
      await API.AdminAPI.quests.sendItineraryNotification(questId, {
        title: questTitle,
        description,
      })

      setDescription('')
      handleClose()
      Notification.showNotification(
        'Notification sent successfully!',
        'success',
      )
    } catch (e) {
      Error.showError(e)
    } finally {
      setIsLoading(false)
    }
  }

  const handleModalClose = () => {
    if (isLoading) return
    setDescription('')
    handleClose()
  }

  return (
    <Modal
      show={showModal}
      onHide={handleModalClose}
      centered
      backdrop={isLoading ? 'static' : true}
      keyboard={!isLoading}
      dialogClassName='experience-add-part-dialog'
      contentClassName='experience-add-part-card'>
      <Modal.Body className='p-0'>
        <div className='experience-add-part'>
          <h2>Send itinerary notification</h2>
          <p className='experience-add-part-lead'>
            Sends a notification to all participants that the itinerary has
            updates. The title is fixed; the image uses the experience header.
            Add an optional custom description below.
          </p>

          <div className='experience-add-part-fields'>
            <div className='experience-f'>
              <label className='experience-f-label' htmlFor='notificationTitle'>
                Notification title
              </label>
              <input
                id='notificationTitle'
                type='text'
                className='experience-f-control'
                value={questTitle || ''}
                disabled
                readOnly
              />
            </div>

            <div className='experience-f'>
              <label
                className='experience-f-label'
                htmlFor='notificationDescription'>
                Notification description
              </label>
              <input
                id='notificationDescription'
                type='text'
                className='experience-f-control'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder='Enter notification description'
                disabled={isLoading}
                autoComplete='off'
              />
            </div>
          </div>

          <div className='experience-modal-actions'>
            <ExperienceButton
              variant='outline'
              onClick={handleModalClose}
              disabled={isLoading}>
              Cancel
            </ExperienceButton>
            <ExperienceButton
              variant='primary'
              isLoading={isLoading}
              disabled={isLoading}
              onClick={handleSendNotification}>
              Send notification
            </ExperienceButton>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SendItineraryNotificationModal
